import apiClient from '@/utils/apiClient'
import GetUserListController from '@/wayfinder/actions/App/Http/Controllers/User/GetUserListController'
import GetUserByIdController from '@/wayfinder/actions/App/Http/Controllers/User/GetUserByIdController'
import WysiwygSaveImageController from '@/wayfinder/actions/App/Http/Controllers/WysiwygSaveImageController'
import GetUserActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/User/GetUserActivitiesByIdController'
import GetUserTokensController from '@/wayfinder/actions/App/Http/Controllers/User/GetUserTokensController'
import AddUserTokensController from '@/wayfinder/actions/App/Http/Controllers/User/AddUserTokensController'
import DeleteUserTokenController from '@/wayfinder/actions/App/Http/Controllers/User/DeleteUserTokenController'
import UsersExportController from '@/wayfinder/actions/App/Http/Controllers/User/UsersExportController'
import UsersImportController from '@/wayfinder/actions/App/Http/Controllers/User/UsersImportController'
import CreateUserController from '@/wayfinder/actions/App/Http/Controllers/User/CreateUserController'
import AddUserAvatarController from '@/wayfinder/actions/App/Http/Controllers/User/AddUserAvatarController'
import DeleteUserController from '@/wayfinder/actions/App/Http/Controllers/User/DeleteUserController'
import DeleteUserAvatarController from '@/wayfinder/actions/App/Http/Controllers/User/DeleteUserAvatarController'
import GetUserSignatureConvertedController from '@/wayfinder/actions/App/Http/Controllers/User/GetUserSignatureConvertedController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import UpdateUserController from '@/wayfinder/actions/App/Http/Controllers/User/UpdateUserController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

function errorSuccessCallback(payload) {
  if (payload.errorCallback) {
    payload.errorCallback()
  }
}

export default {
  // region fetch
  async fetchAllUser({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetUserListController.get())
      .then(async (response) => {
        await commit('setUserList', response.data.users)
        await commit('setUserMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchAllUser', reason)
      })
  },

  async fetchUserByID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetUserByIdController.get({ user: payload.id }))
      .then(async (response) => {
        await commit('setUser', response.data.user)
        await commit('setUserMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchUserByID', reason)
      })
  },

  async fetchNewUser({ commit }) {
    commit('setUser', {})
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'user' } }))
      .then(async (response) => {
        await commit('setUser', response.data.user)
        await commit('setUserMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewUser', reason)
      })
  },

  /**
   *
   * @param commit
   * @param payload
   * @return {Promise<{success: boolean, file_url: string}>}
   */
  saveWysiwygImage({ commit }, payload) {
    const formData = new FormData()

    formData.append('file', payload.file)

    return apiClient
      .route(WysiwygSaveImageController.post(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data)
  },

  fetchUserActivitiesByUserID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetUserActivitiesByIdController.get({ user: payload.user_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchUserTokensByUserID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetUserTokensController.get({ user: payload.user_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createUserTokensByUserID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddUserTokensController.post({ user: payload.user_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteUserTokensByUserID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteUserTokenController.delete({
            user: payload.user_id,
            token: payload.token_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  //region export items
  async fetchAllUserForExport({ commit }, payload) {
    await apiClient
      .route(UsersExportController.post())
      .then(async (response) => {
        window.open(response.data.url)
        processSuccessCallback(payload)
      })
      .catch((reason) => {
        console.error('errors', reason)
        commit('auth/setErrors', reason.response, { root: true })
      })
  },
  //endregion

  //region import items
  async importListUsers({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()
    formData.append('file', payload.file)
    await apiClient
      .route(UsersImportController.post(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(async (response) => {
        if (response.status === 200) {
          if (response.data.errors) {
            commit('setErrorImport', response.data.errors)
            errorSuccessCallback(payload)
          } else if (response.data.users) {
            await commit('setUserList', response.data.users)
            await commit('setUserMetadata', response.data.metadata)
            processSuccessCallback(payload)
          }
        }
      })
      .catch(async (reason) => {
        await console.error('importListUsers', reason)
      })
  },
  //endregion

  // region store
  storeNewUser: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()

    formData.append('data', JSON.stringify(payload.user))
    if (payload.user.new_avatar_file) {
      formData.append('new_avatar_file', payload.user.new_avatar_file)
    }
    if (payload.user.new_signature_file) {
      formData.append('new_signature_file', payload.user.new_signature_file)
    }

    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateUserController.post(), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  addUserAvatar: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    let formData = new FormData()
    formData.append('avatar', payload.new_avatar_file)

    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddUserAvatarController.post({ user: payload.user_id }),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  getUserById: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetUserByIdController.get({ user: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region update
  updateUser: ({ commit, dispatch }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()
    formData.append('data', JSON.stringify(payload.user))
    if (payload.user.new_avatar_file) {
      formData.append('new_avatar_file', payload.user.new_avatar_file)
    }
    if (payload.user.new_signature_file) {
      formData.append('new_signature_file', payload.user.new_signature_file)
    }

    return new Promise((resolve, reject) => {
      apiClient
        .formRoute(UpdateUserController.put({ user: payload.id }), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(async (response) => {
          if (response.status === 201) {
            commit('setUser', response.data.user)
            commit('metadata/updateUserInMetadata', response.data.user, {
              root: true
            })
            commit('metadata/incrementMainKey', null, { root: true })
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region delete
  async deleteUserById({ commit }, payload) {
    await apiClient
      .route(DeleteUserController.delete.delete({ user: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setUserList', response.data.users)
          await commit('setUserMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteUserById', reason)
      })
  },
  deleteUserAvatar: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteUserAvatarController.delete({ user: payload.user_id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  async undoDeleteUserById({ commit }, payload) {
    await apiClient
      .route(DeleteUserController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setUserList', response.data.users)
          await commit('setUserMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteUserById', reason)
      })
  },
  // endregion

  fetchSignatureFormated({ commit }, { signal, ...payload }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetUserSignatureConvertedController.get({ user: payload.id }), {
          params: payload,
          signal
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
